import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

export class FlyttemeddelelseIndflytterFormBuilder {
    public static opretForm(): UntypedFormGroup {
        const result = new UntypedFormBuilder().group({
            navn: ["", Validators.maxLength(30)],
            navnPaaPartner: [null, Validators.maxLength(30)],
            beholdEjerAdresse: [null, Validators.required]
        });

        const navn = result.get("navn");
        const beholdEjerAdresse = result.get("beholdEjerAdresse");
        beholdEjerAdresse.disable(); // Vi ønsker først at vise Ejer/Lejer-info når man indtaster ejers navn.

        navn.valueChanges.subscribe(() => {
            if (navn.value.length === 0) {
                beholdEjerAdresse.setValue(null);
                beholdEjerAdresse.disable();
            } else {
                beholdEjerAdresse.enable();
            }
        });

        return result;
    }
}
